import React from 'react';
import TessereList from '../../components/TessereList';

export default function LaMiaTessera() {
  return (
    <div>
      <div style={{ marginBottom:'20px' }}>
        <h1 style={s.title}>La mia tessera</h1>
        <p style={s.sub}>I codici di tesseramento federale (ASI, FIPAV) associati al tuo profilo.</p>
      </div>
      <TessereList/>
    </div>
  );
}

const s = {
  title: { fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'2px' },
};
